export interface CupcakeStackLayout {
  pieceHeight: number;
  stackBaseY: number;
  stackTopY: number;
  dropTargetY: number;
}

export function cupcakeStackLayout(
  stationHeight: number,
  catchY: number,
  stackLength: number,
): CupcakeStackLayout {
  const pieceHeight = Math.min(
    24,
    Math.max(6, (stationHeight - 115) / Math.max(8, stackLength + 1)),
  );
  const stackBaseY = catchY - 28;
  const stackTopY = stackBaseY - pieceHeight * stackLength;
  return {
    pieceHeight,
    stackBaseY,
    stackTopY,
    dropTargetY: stackTopY - pieceHeight,
  };
}
